import React from "react";
import PropTypes from "prop-types";
import { Row, Select } from "antd";
import { getMaxDate, getScheduleVal } from "../../../utils/report";

const { Option } = Select;

export const YearlyMonthChangeHandler = (value, record, reportType) => {
  let setvalue;
  if (record.schedule_trigger_type === 2) {
    let val2 = getScheduleVal(record, 2);
    if (val2 === undefined) {
      val2 = "Monday";
    }
    let week = getScheduleVal(record, 1);
    if (week === undefined) {
      week = "1";
    }
    setvalue = `${value}_${week}_${val2}`;
  } else if (record.schedule_trigger_type === 1) {
    let date = getScheduleVal(record, 4);
    const max = getMaxDate(reportType, value);
    if (date === undefined || parseInt(date) > max) {
      date = "1";
    }
    setvalue = `${value}_${date}`;
  }
  return setvalue;
};

export const YearlyMonth = (props) => {
  const { value, onChange } = props;
  return (
    <Row justify="center">
      <Select
        value={value}
        onChange={onChange}
        style={{ minWidth: 150 }}
        placeholder="Month"
      >
        <Option value="1">January</Option>
        <Option value="2">February</Option>
        <Option value="3">March</Option>
        <Option value="4">April</Option>
        <Option value="5">May</Option>
        <Option value="6">June</Option>
        <Option value="7">July</Option>
        <Option value="8">August</Option>
        <Option value="9">September</Option>
        <Option value="10">October</Option>
        <Option value="11">November</Option>
        <Option value="12">December</Option>
      </Select>
    </Row>
  );
};

YearlyMonth.propTypes = {};

export default YearlyMonth;
